import { getFramework, type IHistoryItem } from '@/framework';
import type { ILayerProps, IWatermarkLayerProps } from '@/version-types';
import { WATERMARK_HISTORY_KEY } from './constants';

type IHistoryData = {
    newLayer: ILayerProps;
    oldLayer: ILayerProps;
    updateBridge: (layer: ILayerProps) => Promise<void>;
};

export class WatermarkLayerHistory {
    constructor(private id: string) {
        const framework = getFramework(this.id);
        // 注册历史记录
        framework.service.history.register(WATERMARK_HISTORY_KEY, {
            owner: 'layer/watermark',
            collaboration: 'local-only',
            onRedoUndo: async (historyItem: IHistoryItem<IHistoryData>, isRedo: boolean, isUndo: boolean) => {
                const framework = getFramework(this.id);
                const { newLayer, oldLayer } = historyItem.data.data;

                framework.service.mask.show({
                    loading: true,
                    background: true,
                });

                let isFullScreen = false;
                let activeLayerId = '';

                if (isRedo) {
                    framework.service.frame.addOrUpdateLayer(newLayer);
                    isFullScreen = (newLayer.data as IWatermarkLayerProps).isFullScreen;
                    activeLayerId = newLayer.id;
                }
                if (isUndo) {
                    if (oldLayer) {
                        framework.service.frame.addOrUpdateLayer(oldLayer);
                        isFullScreen = (oldLayer.data as IWatermarkLayerProps).isFullScreen;
                        activeLayerId = oldLayer.id;
                    } else {
                        framework.service.frame.delLayer(newLayer.id);
                    }
                }

                if (!isFullScreen && activeLayerId) {
                    framework.service.frame.setActiveLayer(activeLayerId);
                } else {
                    framework.service.frame.delActiveLayer();
                }

                framework.service.mask.hide();
            },
        });
    }
}
